import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.tick()
    this.timer = setInterval(() => this.tick(), 1000)
  }

  disconnect() {
    if (this.timer) clearInterval(this.timer)
  }

  tick() {
    const now = new Date()
    this.element.textContent = now.toLocaleTimeString("en-AU", {
      hour: "numeric",
      minute: "2-digit",
      second: "2-digit",
      hour12: true
    })
  }
}
